import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/security/auth.service';

@Component({
  selector: 'app-oportunidades-redirect',
  template: '' // no necesita HTML
})
export class OportunidadesRedirectComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) {
    console.log('OportunidadesRedirectComponent initialized');
    
  }

  logInfo: any;

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    console.log('Info completa del usuario:', this.logInfo);
    const rol = this.logInfo?.roles?.[0]?.nombreRol;

    console.log('Rol obtenido:', rol);

    if (rol === 'ASESOR EXTERNO') {
      this.router.navigate(['main/oportunidades-comerciales-externos']);
    } else {
      this.router.navigate(['main/oportunidades-comerciales-internos']);
    }
  }
}